import { useCallback } from 'react';
import { TextField } from '@shared/data/entity/fields/TextField';
import { useDefaultFields } from '@shared/scenes/entity/create/hooks/useDefaultFields';
import { useSaveNewEntity } from '@shared/scenes/entity/create/hooks/useSaveNewCardEntity';
import { API } from '@shared/types/api';

export function useCreateRelatedEntity({
  workflowTemplateId,
}: {
  workflowTemplateId?: string | null;
  disabled?: boolean;
}): (name: string) => Promise<API.WorkflowEntity | null> {
  const { saveEntity } = useSaveNewEntity(workflowTemplateId ?? undefined);
  const defaultFields = useDefaultFields({ workflowTemplateId, isViewTemplateRequired: false });

  return useCallback(
    async (name: string) => {
      try {
        const result = await saveEntity({
          ...(defaultFields ?? {}),
          name: new TextField(name, { multiline: true }),
        });
        const newEntity = result?.data?.createWorkflowEntity?.entity;

        return newEntity ?? null;
      } catch {
        return null;
      }
    },
    [saveEntity, defaultFields],
  );
}
